import { flatten } from './helper'

export default function (settings) {

    const { dropDownElement, placeholder, hidden = false } = settings

    if (!dropDownElement.length) return

    const privateOptions = getPrivateOptions()
    const companyOptions = getCompanyOptions()

    const parser = {
        'household-service': 'PRIVATE',
        'staffing-service': 'COMPANY'
    }

    let options = privateOptions

    const form = dropDownElement.parents('form');

    let parentElement = form.find('.service-holder')

    let select = {
        allowClear: true,
        multiple: true,
        data: options,
        placeholder: placeholder,
        dropdownParent: parentElement,
        dropdownPosition: 'below'
    };

    let selectElement = dropDownElement.select2(select), privateValues = [], companyValues = []

    if ($('input[name="service-contact-hidden"]').length) {
        selectElement.val($('input[name="service-contact-hidden"]').val().split(',')).trigger('change');
    }

    const checked = hidden ? form.find('.form-hidden.service').val() : form.find('.form-check-input.service:checked').val()

    let selectedRadio = parser[checked]

    selectElement.on('change', function (e) {

        const values = $(this).val();

        if (selectedRadio === 'PRIVATE') {
            privateValues = Array.from(new Set([...privateValues, ...values]));
        }

        if (selectedRadio === 'COMPANY') {
            companyValues = Array.from(new Set([...companyValues, ...values]));
        }

        $('body').css('overflow', '')

    })

    $('#place-registration-of-interest').on('focus', function (e) {
        $('.registration-of-interest.first').show()
        $('.registration-of-interest.first + .info').show()
    })

    // toggle option groups
    $('body').find(form).on('click', '.select2-results__group', function () {
        $(this).siblings().toggleClass('open');
    })

    if (!hidden) {

        // Select a radio option
        form.find('.form-check-input.service').on('click', function (e) {

            $('#temp-placeholder span').text()

            selectedRadio = parser[$(this).val()]

            dropDownElement.attr('disabled', false)

            dropDownElement.html('');

            if (selectedRadio === 'PRIVATE') {
                options = privateOptions
            }

            if (selectedRadio === 'COMPANY') {
                options = companyOptions
            }

            let newData = Object.assign(select, { data: options });

            dropDownElement.select2(newData)

            if (selectedRadio === 'PRIVATE') {
                dropDownElement.val(privateValues).trigger('change');
            }

            if (selectedRadio === 'COMPANY') {
                dropDownElement.val(companyValues).trigger('change');
            }

            const companyName = $('#company-name').parent()

            const governmentID = $('.form-group.new-version.government-identification')

            if (selectedRadio === 'PRIVATE') {
                companyName.removeClass('show')
            }

            // // check if company
            if (selectedRadio === 'COMPANY') {
                companyName.addClass('show')
                governmentID.show()
            } else {
                governmentID.hide()
            }

        })

        form.find('.form-check-input.service').each(function (index, el) {

            if (el.id.includes('household-service') && el.checked) {
                options = privateOptions
            }

            if (el.id.includes('staffing-service') && el.checked) {
                options = companyOptions
            }
        })

        form.find('.form-check-input.service').on('change', function (e) {

            if ($('#temp-placeholder').length) {
                $('#temp-placeholder').hide()
            }

            $('body').css('overflow', '')
        })

    } else {
        options = checked.includes('household-service') ? privateOptions : companyOptions
    }

    dropDownElement.html('');

    selectElement = dropDownElement.select2(Object.assign(select, { data: options }))

    const input = form.find('input[name="service-contact-hidden"]')

    let val = input.length && input.val().length ? input.val().split(',') : null

    dropDownElement.val(val).trigger('change');

    let path = window.location.pathname;

    if (path.includes('/tjanst/')) {

        const flat = options.flatMap(({ children, ...item }) => children ? flatten(children) : item);

        path = path.replace(/\/$/, '')

        const part = path.split('/').pop();

        let found = []

        flat.forEach(each => {

            if (part === each.id) {
                found.push(each.id)
                return
            }
        })

        if (!hidden) {

            if (selectedRadio === 'COMPANY') {
                form.find('[name="staffing-service"]').click()
            } else {
                form.find('[name="household-service"]').click()
            }

        }

        dropDownElement.val(found).trigger('change');
    }

    dropDownElement.on('select2:clear', function (e) {
        if (input.length) {
            input.remove()
        }
    })

    dropDownElement.on('select2:closing', function (e) {

        $('body').css('overflow', '')

        if ($('#temp-placeholder').length) {

            if ($(this).val().length > 0 && $(this).val().length < 2) {

                $('#temp-placeholder span').text('Lägg till fler tjänster')

                const width = $('.select2-selection__rendered').width()

                let newWidth = width + 10

                const segments = window.location.pathname.replace(/\/$/, '').split('/');

                const slug = segments[segments.length - 1];

                if (slug === 'intresseanmalan' || slug === 'rekrytering') {
                    newWidth = newWidth + 10
                }

                const withClose = newWidth + 25

                $('#temp-placeholder').show()
                $('#temp-placeholder').css({
                    'left': newWidth + 15,
                    'width': 'calc(100% - ' + withClose + 'px)'
                })

            } else {
                $('#temp-placeholder').hide()
            }

        }

    });

    dropDownElement.on('select2:open', function (e) {

        e.preventDefault()

        const requireHeight = form.find('.select2-dropdown').height() + 10

        const viewportBottom = $(window).height() - dropDownElement.offset().top

        const control = form.find('.form-control.service-contact')

        const offset = viewportBottom < requireHeight ? control.offset().top - 10 : control.offset().top / 2

        $('html, body').animate({
            scrollTop: offset
        }, 1000, function () {
            $('body').css('overflow', 'hidden')
        });

    });

}


const getPrivateOptions = function () {

    let options = as_contact_settings.options.private

    if (as_contact_settings.options.campaign) {
        options = [...options, ...as_contact_settings.options.campaign]
    }

    return options
}

const getCompanyOptions = function () {
    return as_contact_settings.options.company
}